import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetConversationsSuspenseQuery = () => {
    const client = useAiApiClient();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetConversations(),
        queryFn: async() => {
            const data = await client.getConversations();

            return data;
        }
    });
};
